//Force encoding -> _Íì_ 
exports.getDoors = function() {
	return[
		{	"id" : 1
			,"name" : "Multipanel"
			,"link" : ""
			,"r_value" : 8.12
			,"u_value" : 0.6993
			,"thermal_resistance" : 1.43
			,"complies_2001" : "No"
		},
		{	"id" : 2
			,"name" : "Madera"
			,"link" : ""
			,"r_value" : 2.5
			,"u_value" : 2.2492
			,"thermal_resistance" : 0.4446
			,"complies_2001" : "No"
		}
	];
}
